// extracted by mini-css-extract-plugin
export var backHomeButton = "pages-module--backHomeButton--Hvjvw";
export var imageContainer = "pages-module--imageContainer--4BRp4";
export var notFound = "pages-module--notFound--ctYTo";
export var sbShowMain = "pages-module--sb-show-main--FSAdo";